module.exports = __webpack_public_path__ + "static/img/AISPARK.a8653aa2.png";